import React from 'react';
import { Check, Cpu } from 'lucide-react';
import { aiBullets } from '../mock';

const AISection = () => {
  return (
    <section id="ai" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-12 items-center">
        <div className="relative">
          <div className="relative bg-gradient-to-br from-[#2C5F66] to-[#1f4a50] rounded-2xl p-12 aspect-square flex items-center justify-center shadow-2xl overflow-hidden">
            <div className="absolute -top-20 -right-20 w-64 h-64 rounded-full bg-[#D9A04A]/10 blur-3xl" />
            <div className="absolute -bottom-16 -left-16 w-72 h-72 rounded-full bg-white/5 blur-3xl" />
            <div className="relative z-10 flex flex-col items-center">
              <Cpu size={120} className="text-[#D9A04A]" strokeWidth={1.2} />
              <span className="mt-8 text-white text-7xl font-extrabold tracking-tighter">A.I.</span>
              <span className="text-white/70 mt-2 tracking-widest text-sm">INTELLIGENT SOLUTIONS</span>
            </div>
          </div>
          <a href="#" className="absolute -bottom-5 left-1/2 -translate-x-1/2 bg-[#C68B30] hover:bg-[#B17A24] text-white font-semibold px-8 py-3 rounded-md transition-colors shadow-lg">
            Learn More
          </a>
        </div>

        <div>
          <h3 className="text-[#D9A04A] text-lg font-semibold tracking-wider mb-3">Artificial Intelligence Services</h3>
          <h2 className="text-[#2C5F66] text-3xl md:text-5xl font-extrabold mb-6 leading-tight">
            A.I. Integration Services
          </h2>
          <p className="text-gray-600 text-[15px] leading-relaxed mb-8">
            At <strong className="text-[#2C5F66]">Website Symphony</strong>, we help businesses harness the power of <strong>Artificial Intelligence</strong> to automate processes, improve customer experiences, and drive measurable growth. Our <strong>A.I. integration services</strong> are designed to seamlessly connect intelligent technology with your existing website, tools, and workflows—without disrupting your operations.
          </p>
          <ul className="space-y-3">
            {aiBullets.map((b) => (
              <li key={b} className="flex items-start gap-3 text-gray-700">
                <span className="mt-0.5 w-6 h-6 rounded-full bg-[#2C5F66] flex items-center justify-center flex-shrink-0">
                  <Check size={14} className="text-white" />
                </span>
                <span className="text-[15px]">{b}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default AISection;
